// App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { Provider, connect } from 'react-redux';
import store from './redux/store';
import Home from './pages/Home/Home';
import Shop from './pages/Shop/Shop';
import Wishlist from './pages/Wishlist/Wishlist';
import Orders from './pages/Orders/Orders'
import Cart from './pages/Cart/Cart';
import Loader from './Components/Loader/Loader';
import TrackOrder from './pages/Orders/TrackOrder';
import ProductDetails from './pages/Product/ProductDetails';
import LoginScreen from './pages/Login/LoginScreen';
import Contact from './pages/Contact/Contact';
import { FolderPath } from './config';

const AppContent = ({ loading }) => {
  //   useEffect(() => {
  //   const disableVisualSearch = () => {
  //     document.querySelectorAll("img").forEach((img) => {
  //       img.setAttribute("data-noimgsearch", "true");
  //     });
  //   };
  //   disableVisualSearch();
  //   const observer = new MutationObserver(disableVisualSearch);
  //   observer.observe(document.body, { childList: true, subtree: true });
  //   return () => observer.disconnect();
  // }, []);
  const base = process.env.NODE_ENV === 'production' ? FolderPath : '/';
  useEffect(() => {
    const hasRefreshed = sessionStorage.getItem('hasRefreshed');
    if (!hasRefreshed) {
      sessionStorage.setItem('hasRefreshed', 'true');
      window.location.reload(true); // true forces hard reload
    }
  }, []);
  
  return (
    <Router basename={base}>
      <AuthGuard base={base}>
        <div>
          <Routes>
            <Route path="/" element={<LoginScreen/>} />
            <Route path="/login" element={<LoginScreen/>} />
            <Route path="/cart" element={<Cart/>} />
            <Route path="/wishlist" element={<Wishlist/>} />
            <Route path="/account" element={<Orders/>} />
            <Route path="/trackorder" element={<TrackOrder/>} />
            <Route path="/shop" element={<Shop/>} />
            <Route path="/view" element={<ProductDetails/>} />
            <Route path="/home" element={<Home/>} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          {loading > 0 && <Loader />}
        </div>
      </AuthGuard>
    </Router>
  );
};

// AuthGuard component to handle authentication and back button prevention
const AuthGuard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const accessToken = localStorage.getItem("accessToken");
  const isInvalidToken =
    !accessToken ||
    accessToken === "undefined" ||
    accessToken === "null" ||
    accessToken.trim() === "";

  const publicRoutes = ["/", "/login", "/register"];
  const isPublic = publicRoutes.includes(location.pathname);

  useEffect(() => {
    if(isInvalidToken && !isPublic) {
      // User not logged in but trying to access protected pages
      navigate("/login", { replace: true });
    }


  }, [location.pathname,accessToken]);

  return children;
};


const mapStateToProps = (state) => ({
  loading: state.loading.loading,
});

const ConnectedAppContent = connect(mapStateToProps)(AppContent);

function App() {
  return (
    <Provider store={store}>
      <ConnectedAppContent />
    </Provider>
  );
}

export default App;